import {priority} from '@priority-software/priority-proto-api/lib';
import {getLocalizedText, texts as constTexts} from '../../../../../../constants/TextConst';
import {OldZoomValues} from '../../enum';

export function optionMapper(
    data: priority.netitems.form.ISelectValues,
    searchType: priority.netitems.shared.FieldSelectType
) {
    if (
        searchType === priority.netitems.shared.FieldSelectType.SearchEdes ||
        searchType === priority.netitems.shared.FieldSelectType.SearchDes
    ) {
        /*
         * Swapped the description and value fields from the new API response to ensure the search by description
         * functions the same way as it did in the old API
         */
        return {
            label: data.Description,
            description: data.Value,
            value: data.Value,
            data: {
                description2: ''
            }
        };
    }
    return {
        label: data.Value,
        description: data.Description,
        value: data.Value,
        data: {
            description2: data.Description2
        }
    };
}

export const mapDateZoomToColumnType = (
    zoomType: priority.netitems.form.ZoomType | OldZoomValues
) => {
    switch (zoomType) {
        case OldZoomValues.date:
            return priority.netitems.form.ColumnType.Date8;
        case priority.netitems.form.ZoomType.Date8Zoom:
            return priority.netitems.form.ColumnType.Date8;
        case priority.netitems.form.ZoomType.Date10Zoom:
            return priority.netitems.form.ColumnType.Date10;
        case priority.netitems.form.ZoomType.Date14Zoom:
            return priority.netitems.form.ColumnType.Date14;
        default:
            return priority.netitems.form.ColumnType.Str;
    }
};

export const getSearchCategoryNameByType = (type: priority.netitems.shared.FieldSelectType) => {
    if (type === priority.netitems.shared.FieldSelectType.SearchEdes) {
        return getLocalizedText(constTexts.searchByOtherCriteria);
    } else if (type === priority.netitems.shared.FieldSelectType.SearchDes) {
        return getLocalizedText(constTexts.searchByName);
    } else if (type === priority.netitems.shared.FieldSelectType.SearchName) {
        return getLocalizedText(constTexts.searchByNumber);
    }
    return '';
};
